// src/DetailingForm.jsx
import React, { useState } from 'react';
import { signInWithRedirect } from 'aws-amplify/auth';
import { useSession } from './auth/SessionProvider.jsx';
import { api } from './lib/apiFetch';

const UPDATE_PATH = '/updatedetailinglist';

export default function DetailingForm({ item, onCancelEdit, onSuccessfulSubmit }) {
  const { signedIn } = useSession();

  const [formData, setFormData] = useState({
    unitNumber:  item.unitNumber  ?? '',
    style:       item.style       ?? '',
    lastCleaned: item.lastCleaned ?? '',
    availStart:  item.availStart  ?? '',
    availEnd:    item.availEnd    ?? '',
    nextStart:   item.nextStart   ?? '',
    nextEnd:     item.nextEnd     ?? '',
  });

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((s) => ({ ...s, [name]: value }));
  };

  const resetForm = () => {
    setFormData({
      unitNumber: '', style: '', lastCleaned: '',
      availStart: '', availEnd: '', nextStart: '', nextEnd: '',
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!signedIn) {
      setError('Please sign in before saving.');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      // include identifiers your backend expects
      const body = { id: item.id, type: item.type, ...formData };

      const resp = await api.post(UPDATE_PATH, body);
      if (resp?.ok === false) throw new Error(resp?.message || 'Save failed.');

      resetForm();
      onSuccessfulSubmit?.();
      onCancelEdit?.();
    } catch (err) {
      setError(err?.message || 'Error submitting form. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <h2>Edit Detailing Item</h2>

      {!signedIn && (
        <div style={{ marginBottom: 12 }}>
          <div style={{ color: 'crimson', marginBottom: 6 }}>
            You must sign in to save changes.
          </div>
          <button className="link-btn" onClick={() => signInWithRedirect()}>
            Sign in
          </button>
        </div>
      )}

      {error && (
        <div style={{ color: 'crimson', marginBottom: 8 }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="form-container">
        <div className="input-row">
          <div className="input-group">
            <label htmlFor="unitNumber">Unit Number:</label>
            <input
              type="text" id="unitNumber" name="unitNumber"
              value={formData.unitNumber} onChange={handleInputChange}
              disabled={!signedIn || submitting}
            />
          </div>
          <div className="input-group">
            <label htmlFor="style">Style:</label>
            <input
              type="text" id="style" name="style"
              value={formData.style} onChange={handleInputChange}
              disabled={!signedIn || submitting}
            />
          </div>
          <div className="input-group">
            <label htmlFor="lastCleaned">Last Cleaned:</label>
            <input
              type="text" id="lastCleaned" name="lastCleaned"
              value={formData.lastCleaned} onChange={handleInputChange}
              disabled={!signedIn || submitting}
            />
          </div>
        </div>

        <div className="input-row">
          <div className="input-group">
            <label htmlFor="availStart">Availability Start:</label>
            <input
              type="text" id="availStart" name="availStart"
              value={formData.availStart} onChange={handleInputChange}
              disabled={!signedIn || submitting}
            />
          </div>
          <div className="input-group">
            <label htmlFor="availEnd">Availability End:</label>
            <input
              type="text" id="availEnd" name="availEnd"
              value={formData.availEnd} onChange={handleInputChange}
              disabled={!signedIn || submitting}
            />
          </div>
          <div className="input-group">
            <label htmlFor="nextStart">Next Start:</label>
            <input
              type="text" id="nextStart" name="nextStart"
              value={formData.nextStart} onChange={handleInputChange}
              disabled={!signedIn || submitting}
            />
          </div>
          <div className="input-group">
            <label htmlFor="nextEnd">Next End:</label>
            <input
              type="text" id="nextEnd" name="nextEnd"
              value={formData.nextEnd} onChange={handleInputChange}
              disabled={!signedIn || submitting}
            />
          </div>
        </div>

        <div className="button-container">
          <button type="submit" disabled={!signedIn || submitting}>
            {submitting ? 'Saving…' : 'Save'}
          </button>
          <button type="button" onClick={onCancelEdit} disabled={submitting}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}
